import { render, staticRenderFns } from "./SelectorAccidentLaborProtection.vue?vue&type=template&id=4dc1d27e&"
import script from "./SelectorAccidentLaborProtection.vue?vue&type=script&lang=ts&"
export * from "./SelectorAccidentLaborProtection.vue?vue&type=script&lang=ts&"
import style0 from "./SelectorAccidentLaborProtection.vue?vue&type=style&index=0&id=4dc1d27e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports